export enum ThirdParty {
  APPLE = 'Apple',
  GOOGLE = 'Google',
  FACEBOOK = 'Facebook',
}

export default ThirdParty
